/* eslint-disable eqeqeq */
import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  defaultLimitPagination,
  get,
  riskProfile,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import { useLocation } from "react-router-dom";
import {
  formatMobile,
  formatName,
  formatPhone,
  getModuleNamingBySlug,
} from "../../../lib/Misc";
import BootstrapTable from "react-bootstrap-table-next";
import Pagination from "../../../components/Pagination";
import { debounce } from "lodash";
import MainBody from "../../../components/MainBody/MainBody";
import sortCaret from "../../../components/SortCaret";
import { useTrust } from "../../../lib/context/TrustContext";
// import { Button } from "../../../components/ui/button";
import { LucideMessageSquareShare, Verified, XOctagon } from "lucide-react";
import { useOrganization } from "../../../lib/context/OrganisationContext";
import ExpandCDD from "./ExpandCDD";
import { CaretDownIcon, CaretRightIcon } from "@radix-ui/react-icons";
import CustomTooltip from "../../../components/CustomTooltip";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import VerifyModal from "./VerifyModal";
import RiskChange from "./RiskChange";
import EscalatedModal from "./EscalatedModal";
import UnauthorisedAccess from "../../../UnauthorisedAccess";

// * Start: Vendor Listing Page
const EnhancedCDD = ({ sectionType, readAccess, writeAccess }) => {
  // * Start: Url Management State
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const search = query.get("search");
  const defaultPage = query.get("page");
  const defaultLimit = query.get("limit");
  const { organizationData } = useOrganization();

  // * End: Url Management State

  // * Start: List Management State

  const { trustId } = useTrust();
  const [enhancedCDDsList, setEnhancedCDDsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sortField, setSortField] = useState();
  const [sortOrder, setSortOrder] = useState();
  const [searchParam, setSearchParam] = useState(search || "");
  const [searchParamData, setSearchParamData] = useState(search || "");
  const [page, setPage] = useState(defaultPage || 1);
  const [limit, setLimit] = useState(defaultLimit || defaultLimitPagination);
  const [total, setTotal] = useState();
  const [from, setFrom] = useState();
  const [to, setTo] = useState();

  const [confirmEscalated, setConfirmEscalated] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [cddId, setCddId] = useState("");
  const [cddItem, setCddItem] = useState("");

  // const [mobile, setMobile] = useState();
  // const [consent, setConsent] = useState();

  const [showVisual, setShowVisual] = useState(false);
  const [showRisk, setShowRisk] = useState(false);

  // * End: List Management State

  /**
   * * Start: Fetch Vendor List Form The API
   * @param {Number} passLimit (Number of Limit for each page)
   * @param {Number} passPage (Number of Page for records)
   * @returns {Array} Vendor List
   **/

  const fetchEnhancedCDDs = useCallback(
    async (passLimit, passPage) => {
      try {
        setLoading(true);
        const { data } = await get(
          `${API.GET_CDDS}?limit=${
            passLimit ? passLimit : limit ? limit : defaultLimitPagination
          }&page=${passPage ? passPage : page ? page : 1}&search=${
            searchParam ? searchParam : ""
          }&sort_column=${sortField ? sortField : ""}&sort_order=${
            sortOrder ? sortOrder : ""
          }&trust_id=${trustId}&cdd=1&cdd_customer_type=${sectionType}&organization_id=${
            organizationData?.organizationId
              ? organizationData?.organizationId
              : ""
          }`,
        );
        setLoading(false);
        setLimit(data?.data?.per_page);
        setPage(data?.data?.current_page);
        setTotal(data?.data?.total);
        setFrom(data?.data?.from);
        setTo(data?.data?.to);
        const enhancedCDDsList = data.data.data;
        setEnhancedCDDsList(enhancedCDDsList);
        return data.data;
      } catch (error) {
        setEnhancedCDDsList([]);
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [searchParam, sortOrder, sortField, trustId, sectionType, organizationData],
  );

  //* End: Fetch Vendor List Form The API

  const toggleConfirmEscalated = (id, data) => {
    if (confirmEscalated) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setConfirmEscalated(!confirmEscalated);
  };

  const toggleVisual = (id, data) => {
    if (showVisual) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowVisual(!showVisual);
  };

  const toggleRisk = (id, data) => {
    if (showRisk) {
      setCddId();
      setCddItem();
    } else {
      setCddId(id);
      setCddItem(data);
    }
    setShowRisk(!showRisk);
  };

  // const handleVerifyID = async () => {
  //   try {
  //     setLoading(true);
  //     await get(
  //       `${API.GET_CDD_VERFIY}/${cddId}?cdd=1&cdd_customer_type=${sectionType}&mobile=${mobile}`,
  //     );
  //     setLoading(false);
  //     fetchEnhancedCDDs();
  //   } catch (error) {
  //     setLoading(false);
  //     fetchEnhancedCDDs();
  //   }
  // };

  /**
   * * Start: Vendor Table List Record Generation
   * @param {Number} quantity (Number of EnhancedCDDs)
   * @returns {Array} Vendor List
   **/

  const enhancedCDDsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      let contact = enhancedCDDsList[i]?.vendor_id
        ? enhancedCDDsList[i]?.vendor
        : enhancedCDDsList[i]?.contact_id
          ? enhancedCDDsList[i]?.contact
          : "";
      items.push({
        key: enhancedCDDsList[i]?.id,
        id: enhancedCDDsList[i]?.id ? enhancedCDDsList[i]?.id : "",
        contact_type: enhancedCDDsList[i]?.vendor_id
          ? getModuleNamingBySlug(
              organizationData?.organizationData,
              "vendors",
              "Vendor",
            )
          : enhancedCDDsList[i]?.contact_id
            ? getModuleNamingBySlug(
                organizationData?.organizationData,
                "contacts",
                "Customer",
              )
            : "",
        code: contact?.code ? contact?.code : "",
        name:
          formatName(contact?.first_name, contact?.last_name) +
          (contact?.business_name ? ` (${contact?.business_name})` : ""),
        email: contact?.email,
        phone: contact?.phone ? formatPhone(contact?.phone) : "-",
        mobile: contact?.mobile ? formatMobile(contact?.mobile) : "-",
        risk: (
          <div className="flex items-center gap-2">
            {enhancedCDDsList[i]?.risk
              ? riskProfile?.find(
                  (item) => item.value == enhancedCDDsList[i]?.risk,
                )?.label
              : ""}{" "}
            <CustomTooltip message={"Edit"}>
              <span>
                <FontAwesomeIcon
                  icon={faEdit}
                  size="1x"
                  onClick={() => {
                    toggleRisk(enhancedCDDsList[i]?.id, enhancedCDDsList[i]);
                  }}
                />
              </span>
            </CustomTooltip>
          </div>
        ),
        source: enhancedCDDsList[i]?.source ? enhancedCDDsList[i]?.source : "",
        verifications: enhancedCDDsList[i]?.verifications
          ? enhancedCDDsList[i]?.verifications
          : "",
        bureau:
          enhancedCDDsList[i]?.bureau === 1 ? (
            <div className="flex items-center gap-2">
              <span>
                <Verified size={18} className="text-green-500" />
              </span>{" "}
              Bureau
            </div>
          ) : enhancedCDDsList[i]?.bureau === 0 ? (
            <div className="flex items-center gap-2">
              <span>
                <XOctagon size={18} className="text-red-500" />
              </span>
              Bureau
            </div>
          ) : (
            ""
          ),
        dvs:
          enhancedCDDsList[i]?.dvs === 1 ? (
            <div className="flex items-center gap-2">
              <span>
                <Verified size={18} className="text-green-500" />
              </span>{" "}
              DVS
            </div>
          ) : enhancedCDDsList[i]?.dvs === 0 ? (
            <div className="flex items-center gap-2">
              <span>
                <XOctagon size={18} className="text-red-500" />
              </span>
              DVS
            </div>
          ) : (
            ""
          ),
        pep:
          enhancedCDDsList[i]?.pep === 1 ? (
            <div className="flex items-center gap-2">
              <span>
                <Verified size={18} className="text-green-500" />
              </span>{" "}
              PEP
            </div>
          ) : enhancedCDDsList[i]?.pep === 0 ? (
            <div className="flex items-center gap-2">
              <span>
                <XOctagon size={18} className="text-red-500" />
              </span>
              PEP
            </div>
          ) : (
            ""
          ),
        sanction:
          enhancedCDDsList[i]?.sanction === 1 ? (
            <div className="flex items-center gap-2">
              <span>
                <Verified size={18} className="text-green-500" />
              </span>{" "}
              Sanction
            </div>
          ) : enhancedCDDsList[i]?.sanction === 0 ? (
            <div className="flex items-center gap-2">
              <span>
                <XOctagon size={18} className="text-red-500" />
              </span>
              Sanction
            </div>
          ) : (
            ""
          ),
        action: (
          <>
            {enhancedCDDsList[i]?.source !== "Visual" ? (
              // enhancedCDDsList[i]?.status !== 1 &&
              // <Button
              //   onClick={() => {
              //     toggleConfirmEscalated(
              //       enhancedCDDsList[i]?.id,
              //       enhancedCDDsList[i],
              //     );
              //   }}
              // >
              //   <div className="flex items-center gap-1">
              <span className="flex items-center gap-2 justify-center">
                <CustomTooltip message={"Escalate"}>
                  <span>
                    <LucideMessageSquareShare
                      size={18}
                      onClick={() => {
                        toggleConfirmEscalated(
                          enhancedCDDsList[i]?.id,
                          enhancedCDDsList[i],
                        );
                      }}
                    />
                  </span>
                </CustomTooltip>
              </span>
            ) : (
              //     <span>Escalate</span>
              //   </div>
              // </Button>
              <span className="flex items-center gap-2 justify-center">
                {/* <Button
                  onClick={() => {
                    toggleConfirmEscalated(
                      enhancedCDDsList[i]?.id,
                      enhancedCDDsList[i],
                    );
                  }}
                >
                  <div className="flex items-center gap-1"> */}
                <CustomTooltip message={"Escalate"}>
                  <span>
                    <LucideMessageSquareShare
                      size={18}
                      onClick={() => {
                        toggleConfirmEscalated(
                          enhancedCDDsList[i]?.id,
                          enhancedCDDsList[i],
                        );
                      }}
                    />
                  </span>
                </CustomTooltip>
                {/* <span>Escalate</span>
                  </div>
                </Button> */}
                <span>/</span>
                <CustomTooltip message={"Edit"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faEdit}
                      size="1x"
                      onClick={() => {
                        toggleVisual(
                          enhancedCDDsList[i]?.id,
                          enhancedCDDsList[i],
                        );
                      }}
                    />
                  </span>
                </CustomTooltip>
              </span>
            )}
          </>
        ),
      });
    }
    return items;
  };

  const enhancedCDDs = enhancedCDDsGenerator(enhancedCDDsList?.length);

  //* End: Vendor Table List Record Generation

  //* Start: Vendor List Columns

  const columns = [
    {
      dataField: "contact_type",
      text: "Contact type",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "code",
      text: "Code",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "name",
      text: "Name",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "phone",
      text: "Phone No.",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "mobile",
      text: "Mobile No.",
      sort: true,
      sortCaret,
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "risk",
      text: "Risk Profile",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "source",
      text: "Source",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "dvs",
      text: "DVS",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "bureau",
      text: "Bureau",
      headerClasses: THClasses,
      classes: TDClasses,
    },

    {
      dataField: "pep",
      text: "PEP",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      dataField: "sanction",
      text: "Sanction",
      headerClasses: THClasses,
      classes: TDClasses,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  //* End: Vendor List Columns

  /**
   * * Start: Vendor List Sorting
   * @param {type} (Sort)
   * @param {JSON} (page, sortField, sortOrder) (To get the current value of the table)
   **/
  const handleTableChange = (type, { page, sortField, sortOrder }) => {
    if (type === "sort") {
      setPage(1);
      setSortField(sortField);
      setSortOrder(
        sortOrder === "asc" ? "ASC" : sortOrder === "desc" && "DESC",
      );
    }
  };

  //* End: Vendor List Sorting

  /**
   * * Start: Vendor List Change Limit
   * @param {Event} e (Limit Number)
   **/
  const handleUpdateLimit = (e) => {
    const limit = e.target.value;
    setLimit(limit);
    setPage(1);
    fetchEnhancedCDDs(limit, 1);
  };

  //* End: Vendor List Change Limit

  /**
   * * Start: Vendor List Change Page
   * @param {Number} page (Page Number)
   **/
  const handleChangePage = (page) => {
    setPage(page);
    fetchEnhancedCDDs(limit, page);
  };

  //* End: Vendor List Change Page

  //* Start: Vendor List and URL Mangement useEffect

  useEffect(() => {
    fetchEnhancedCDDs();
  }, [fetchEnhancedCDDs]);

  //* End: Vendor List and URL Mangement useEffect

  //* Start: Vendor List Search Record Management

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const debouncedSave = useCallback(
    debounce((nextValue) => {
      setSearchParam(nextValue);
      setPage(1);
    }, 300),
    [],
  );

  const handleSearchChange = (event) => {
    const { value: nextValue } = event.target;
    setSearchParamData(nextValue);
    setPage(1);
    if (nextValue?.length >= 2 || nextValue?.length === 0) {
      debouncedSave(nextValue);
    }
  };

  const handleClearSearch = () => {
    setSearchParamData();
    setSearchParam("");
  };

  //* End: Vendor List Search Record Management

  const expandRow = {
    renderer: (row) => (
      <>
        <ExpandCDD expandList={true} expandData={row?.verifications} />
      </>
    ),
    onlyOneExpanding: true,
    showExpandColumn: true,
    expandByColumnOnly: true,
    headerClasses: THClasses,
    expandColumnRenderer: ({ expanded }) => {
      if (expanded) {
        return <CaretDownIcon />;
      }
      return <CaretRightIcon />;
    },
    className: TDClasses,
    expandHeaderColumnRenderer: () => {
      return <></>;
    },
  };

  return readAccess ? (
    <>
      <MainBody
        searchParamData={searchParamData}
        handleClearSearch={handleClearSearch}
        handleSearchChange={handleSearchChange}
        actionContent={<></>}
        loading={loading}
        innerBody={true}
        parentHeight={true}
        mainClassName="w-[calc(100%-3rem)]"
      >
        {/* Vendor Table and Pagination */}
        <div className="custom-table">
          <div className="table-body-class">
            <BootstrapTable
              keyField="id"
              remote
              data={enhancedCDDs}
              columns={columns}
              onTableChange={handleTableChange}
              expandRow={expandRow}
              rowClasses={TRClasses}
              noDataIndication="No Data Found"
              classes={TableClasses}
              wrapperClasses={TableWrapClasses}
            />
          </div>

          <Pagination
            total={total}
            limit={parseInt(limit)}
            currentPage={page}
            updateLimit={handleUpdateLimit}
            updatePage={handleChangePage}
            from={from}
            to={to}
          />

          {confirmEscalated && (
            <ResponsiveDrawerForm
              description={""}
              title={`Escalated`}
              handleOpen={() => {}}
              handleClose={() => {
                toggleConfirmEscalated();
              }}
              popupType={"cdds"}
              write={true}
              buttonText={""}
              open={confirmEscalated}
              buttonClassName={""}
              setOpen={setConfirmEscalated}
              className={"sm:max-w-3xl"}
            >
              <EscalatedModal
                data={cddItem}
                toggleConfirmEscalated={toggleConfirmEscalated}
                fetchData={fetchEnhancedCDDs}
              />
            </ResponsiveDrawerForm>
          )}

          {showVisual && (
            <ResponsiveDrawerForm
              description={""}
              title={`Visual Changes`}
              handleOpen={() => {}}
              handleClose={() => {
                toggleVisual();
              }}
              popupType={"cdds"}
              write={true}
              buttonText={""}
              open={showVisual}
              buttonClassName={""}
              setOpen={setShowVisual}
              className={"sm:max-w-3xl"}
            >
              <VerifyModal
                data={cddItem?.verifications[0]}
                toggleVisual={toggleVisual}
                fetchData={fetchEnhancedCDDs}
              />
            </ResponsiveDrawerForm>
          )}

          {showRisk && (
            <ResponsiveDrawerForm
              description={""}
              title={`Risk Change`}
              handleOpen={() => {}}
              handleClose={() => {
                toggleRisk();
              }}
              popupType={"cdds"}
              write={true}
              buttonText={""}
              className={"sm:max-w-3xl"}
              open={showRisk}
              buttonClassName={""}
              setOpen={setShowRisk}
            >
              <RiskChange
                data={cddItem}
                toggleRisk={toggleRisk}
                fetchData={fetchEnhancedCDDs}
              />
            </ResponsiveDrawerForm>
          )}
        </div>
      </MainBody>
    </>
  ) : (
    <UnauthorisedAccess expandList={true} popup={true} />
  );
};

export default EnhancedCDD;
// * End: Vendor Listing Page
